import { HeaderBar } from 'components/HeaderBar';
import PageLayout from 'components/PageLayout';
import { BroadcastifyFeedDetails } from 'features/broadcastify/components/BroadcastifyFeedDetails';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { useAuthState } from 'state/useAuthState';
import { useBroadcastifyFeed } from 'features/broadcastify/hooks/useBroadcastifyFeed';
import { LoadingAndErrors } from 'components/LoadingAndErrors';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { MEMBERSHIP_PLANS } from '../../constants';

export const BroadcastifyFeedPage = (
  props: RouteComponentProps<{ feedId: string; lat: string; lng: string }>,
): JSX.Element => {
  const {
    match: { params },
  } = props;
  const { t } = useTranslation();
  const { showMembershipFeatures } = useAuthState();
  const { broadcastifyFeed, isLoading, error } = useBroadcastifyFeed({
    feedId: Number(params.feedId),
    lat: Number(params.lat),
    lng: Number(params.lng),
  });

  if (!showMembershipFeatures) {
    return <Redirect to={`/support_us/?plan=${MEMBERSHIP_PLANS.proYearly}`} />;
  }

  if (isLoading || error || !broadcastifyFeed) {
    return (
      <PageLayout data-cname="BroadcastifyFeedPage">
        {{
          content: <LoadingAndErrors isLoading={isLoading} />,
          headerBar: <HeaderBar action="back" />,
        }}
      </PageLayout>
    );
  }

  return (
    <PageLayout data-cname="BroadcastifyFeedPage">
      {{
        content: (
          <>
            <Helmet>
              <title>
                {t('broadcastifyFeed.title', { name: broadcastifyFeed.name })}
              </title>
            </Helmet>
            <SimplePageLayout>
              <BroadcastifyFeedDetails {...broadcastifyFeed} />
            </SimplePageLayout>
          </>
        ),
        headerBar: <HeaderBar action="back" />,
      }}
    </PageLayout>
  );
};
